import { useEffect } from 'react';

import { useSocketAuthenticated } from '../../SocketContext';
import api from '../../../../services/api';

const SocketTemplate = ({ dispatch }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const { getSocket } = useSocketAuthenticated();

  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => {
    const socket = getSocket();

    if (socket) {
      const handleTemplates = (data) => {
        if ((['update', 'create'].includes(data.action)) && (`${api.defaults.headers.tenantId}` === `${data.tenantId}`)) {
          dispatch({ type: 'UPDATE_TEMPLATES', payload: data.template });
        }

        if ((data.action === 'bulkUpdate') && (`${api.defaults.headers.tenantId}` === `${data.tenantId}`)) {
          dispatch({ type: 'BULK_UPDATE_TEMPLATES', payload: data.templates });
        }

        if ((data.action === 'delete') && (`${api.defaults.headers.tenantId}` === `${data.tenantId}`)) {
          dispatch({ type: 'DELETE_TEMPLATE', payload: data.templateUuid });
        }
      };

      socket.on('template', handleTemplates);

      return () => {
        socket.off('template', handleTemplates);
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  //  ************
  //  ** Return **
  //  ************
  return (<></>);
};

export default SocketTemplate;